<template>
  <div class="Jump">
    <vue_friendly_iframe :src="link"></vue_friendly_iframe>
  </div>
</template>

<script>
// @ is an alias to /src
import VueFriendlyIframe from 'vue-friendly-iframe';

export default {
  name: 'Jump',
   computed: {
     link () {
       return this.$store.state.enroll.link + this.$store.state.auth.token.token
     }
   },
   components: {
     vue_friendly_iframe: VueFriendlyIframe
   },
   beforeDestroy () {
   }
}
</script>
<style scoped>
 .Jump{
   margin-top: 6.5625vw;
   margin-left: auto;
   margin-right: auto;
   width: 100vw;
 }
 iframe{
   width: 100%;
   height: 70vw;
 }
</style>
